import {useAlert} from "@contexts/hooks/useAlert.ts";
import type {IProduto} from "@models/produtos/produto.js";
import type {ICreateProdutoDto} from "@models/produtos/produtosDto.js";
import {Button, Grid, TextField} from "@mui/material";
import {ToInt} from "@shared/MathHelp.js";
import React, {useState} from "react";
import {useProduto} from "@components/produtos/hooks/useProduto.ts";

interface ProdutoCreateComponentProps {
    onCreate?: (p: IProduto) => void
}

export const ProdutoCreateComponent: React.FC<ProdutoCreateComponentProps> = ({onCreate}) => {
    const {createAlertFromResponse} = useAlert()
	const {createProduto} = useProduto()

    const [dados, setDados] = useState<ICreateProdutoDto>({
        nome: '',
        descricao: ''
    })

    const createProdutoHandler = () => {
	    createProduto(dados).then(x => {
            createAlertFromResponse(x)
            if (x.status == 'Success') {
                if (onCreate) {
                    onCreate(x.items)
                }
            }
        })
    }

    return (
        <Grid container>
            <Grid size={12}>
                <TextField fullWidth label={'Nome'}
                           variant={'filled'}
                           value={dados.nome} onChange={e => {
                    setDados({...dados, nome: e.target.value})
                }}/></Grid>
            <Grid size={12}>
                <TextField fullWidth label={'Descrição'}
                           variant={'filled'}
                           value={dados.descricao ?? ''} onChange={e => {
                    setDados({...dados, descricao: e.target.value})
                }}/>
            </Grid>
            <Grid size={12}>
                <TextField fullWidth label={'ID ERP'}
                           variant={'filled'}
                           type={'number'} value={dados.idErp ?? ''} onChange={e =>
                    setDados({...dados, idErp: ToInt(e.target.value)})
                }/>
                <TextField fullWidth label={'ID Familia ERP'}
                           variant={'filled'}
                           type={'number'} value={dados.idFamiliaErp ?? ''} onChange={e =>
                    setDados({...dados, idFamiliaErp: ToInt(e.target.value)})
                }/>
            </Grid>
            <Grid size={12}>
                <Button fullWidth variant="outlined" color="primary" onClick={createProdutoHandler}>Criar</Button>
            </Grid>
        </Grid>
    )
}